/**
 * Passaggio del token dal popup di fallback alla tab.
 *
 * Le linee guida Teams sconsigliano di mettere il token nel parametro di
 * `notifySuccess` (chiunque abbia aperto la finestra di autenticazione lo
 * riceverebbe). Così invece il popup scrive il token in localStorage, con
 * scadenza breve, e la tab lo preleva e lo cancella subito.
 */

export const SSO_TOKEN_KEY = 'teams-app-intraenea.sso-token';

/** Il token resta valido per il passaggio per due minuti. */
export const SSO_TOKEN_TTL_MS = 120_000;

interface StoredToken {
  token: string;
  storedAt: number;
}

/** Scrive il token nell'handoff (chiamato dal popup). */
export function storeToken(storage: Storage, token: string, now: number = Date.now()): void {
  const payload: StoredToken = { token, storedAt: now };
  storage.setItem(SSO_TOKEN_KEY, JSON.stringify(payload));
}

/** Legge e cancella il token; null se assente, illeggibile o scaduto. */
export function takeToken(
  storage: Storage,
  now: number = Date.now(),
  ttlMs: number = SSO_TOKEN_TTL_MS,
): string | null {
  const raw = storage.getItem(SSO_TOKEN_KEY);
  if (!raw) return null;
  storage.removeItem(SSO_TOKEN_KEY);

  let parsed: StoredToken;
  try {
    parsed = JSON.parse(raw) as StoredToken;
  } catch {
    return null;
  }
  if (typeof parsed.token !== 'string' || !parsed.token) return null;
  if (typeof parsed.storedAt !== 'number' || now - parsed.storedAt > ttlMs) return null;
  return parsed.token;
}
